module.exports = __webpack_public_path__ + "static/media/mc_glossary.2d27ab71.svg";